import { render, staticRenderFns } from "./AnnotationDetailsContainer.vue?vue&type=template&id=6f28865f&scoped=true&"
import script from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationDetailsContainer.vue?vue&type=style&index=0&id=6f28865f&scoped=true&lang=css&"
import style1 from "./AnnotationDetailsContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28865f",
  null
  
)

export default component.exports